<template>
  <div class="clearfix">
    <ul class="nav navbar-nav flex-row float-right nav-icon text-center" id="HeaderRightMenuList">
      <li class="nav-item nav-item-menu" :style="{ height: headerHeight +'px'}">
        <div class="btn btn-group w-100 h-100 py-1 px-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
          <a class="nav-menu-click-cover" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>

          <a class="nav-icon nav-link nav-menu" href="javascript:void(0)">
            <i class="fa fa-list" :class="iconSizeClass" aria-hidden="true"></i>
            <p style="font-size:0.5em;">
              <trans-text i18nKey="ui[1][8]"/>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right py-0 my-0">
            <div>
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert" ><trans-text i18nKey="ui[1][12]"/></a>
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert" ><trans-text i18nKey="ui[1][15]"/></a>
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert" ><trans-text i18nKey="ui[1][13]"/></a>
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert" ><trans-text i18nKey="ui[1][14]" :adjustLangFontSizes="{en:0.8}"/></a>
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert" ><trans-text i18nKey="ui[1][17]"/></a>
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert" ><trans-text i18nKey="ui[1][7]"/></a>
              <a href="javascript:void(0)" v-if="isLoggedInPage" class="dropdown-item" @click="logout"><trans-text i18nKey="ui[12][1]"/></a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    props:{
      iconSizeClass:String,
      headerHeight:String,
    },
    components: {
    },
    data () {
      return {
      }
    },
    computed:{
      isLoggedInPage(){
        return this.$route.matched.some(route => route.meta.isLoggedInPage)
      }
    },
    methods:{
      logout(){
        this.$emit('logout')
      }

    }
  }
</script>


<style lang="scss" scoped>

  .nav{
    .nav-item {
      width: 65px;
      margin: 0;
      .nav-menu-click-cover{
        position:absolute;
        width: 100%;
        height:100%;
      }
      a.nav-icon{
        font-size: 0.7rem;
        font-weight: bold;
        color: #fff !important;
        &.nav-menu {
          padding: 0;
          margin: 0 auto;
        }
      }
      &.nav-item-contact {
        background-color: #91bf32;
      }
      &.nav-item-menu {
        background-color: #ea502e;
        .dropdown-menu {
          border-radius: 0;
          .dropdown-item{
            line-height: 2rem;
            padding-top:.5rem;
            padding-bottom:.5rem;
            min-width: 16em;
            position: relative;
            &:not(:last-child) {
              border-bottom: 1px solid #ccc;
            }
            &:before{
              color:#f9591f;
              font-family: FontAwesome;
              content: '\f054';
              font-size:1.2rem;
              position: absolute;
              top: 50%;
              transform: translateY(-50%) translateX(0);
              right: 5%;
            }
          }
        }
      }
    }

    .dropdown-item{
      background-color: #fbdaa6;
    }
  }
</style>



// WEBPACK FOOTER //
// HeaderRightMenuMobile.vue?10fcaf60